import React from 'react';
import { GroupButton } from 'common/ButtonComponent';
import { ModalComponent } from "common/ModalComponent";
import i18n from "../../i18n"

const ButtonContainer = (props) => {
  // const [showApproveModal, toggleShowApproveModal] = React.useState(false);
  const [showApprove, toggleShowApprove] = React.useState(false);
  const [showReject, toggleShowReject] = React.useState(false);
  const handleClickClaim = () => {
    props.getClaim();
  };
  const handleClickModalCancelApprove = () => {
    toggleShowApprove(!showApprove);
  }
  const handleClickModalCancelApproveSuccess = () => {
      props.closeShowApproveSuccess();
  }
  const handleClickModalCancelReject = () => {
    toggleShowReject(!showReject);
  }
  const handleClickApprove = () => {
    toggleShowApprove(!showApprove);
  };
  const handleClickModalApprove = () => {
    toggleShowApprove(!showApprove);
    props.getApprove();
  }
  const handleClickModalReject = () => {
    toggleShowReject(!showReject);
    props.getReject();
  }
  const handleClickReject = () => {
    toggleShowReject(!showReject);
  };
 const modalFooterApprove = () => ({
    primaryButtonText: "Approve",
    secondaryButtonText: "Cancel",
    primaryButtonKind:"primary",
    secondaryButtonKind:"secondary"
  });
  const modalFooterReject = () => ({
    primaryButtonText: "Reject",
    secondaryButtonText: "Cancel",
    primaryButtonKind:"danger",
    secondaryButtonKind:"secondary"
  });
  const modalFooterApproveSuccess = () => ({
    primaryButtonText: "Ok",
    secondaryButtonText: "Cancel",
    primaryButtonKind:"primary",
    secondaryButtonKind:"secondary"
  });
  const ApproveConfirmation = i18n.t('manageAutomation.ApproveConfirmation');
  const ApproveSuccess = i18n.t('manageAutomation.ApproveSuccess');
  const RejectConfirmation = i18n.t('manageAutomation.RejectConfirmation');
  const Claim = i18n.t('manageAutomation.Claim');
  const Reject = i18n.t('manageAutomation.Reject');
  const Approve = i18n.t('manageAutomation.Approve');
  const EditApprove = i18n.t('manageAutomation.EditApprove');
  return (
    <div>
        {
            (props.status === 'Ready')
            ?
            <GroupButton onClick={handleClickClaim}>{Claim}</GroupButton>
            :
            (props.status === 'Reserved') &&
            <div>
                <GroupButton className="btn-margin-message" kind="tertiary" onClick={handleClickReject}>{Reject}</GroupButton>
                {/* <GroupButton  className="btn-margin-message" kind="tertiary" outline >{EditApprove}</GroupButton> */}
                <GroupButton  className="btn-margin-message" kind="tertiary" onClick={handleClickApprove}>{Approve}</GroupButton>
            </div>
        }
        {showApprove ? <ModalComponent kind="tertiary" children={ApproveConfirmation} modalFooter = {modalFooterApprove()} onClickSecondary={handleClickModalCancelApprove} onClick={handleClickModalApprove} /> : ''}
        {showReject ? <ModalComponent kind="danger" children={RejectConfirmation} modalFooter = {modalFooterReject()} onClickSecondary={handleClickModalCancelReject} onClick={handleClickModalReject} /> : ''}
        {props.approveSuccessModal ? <ModalComponent kind="tertiary" children={ApproveSuccess} modalFooter = {modalFooterApproveSuccess()} onClickSecondary={handleClickModalCancelApproveSuccess} onClick={handleClickModalCancelApproveSuccess} /> : ''}
    </div>
  );

};
export default ButtonContainer;